import { createAction, props } from '@ngrx/store';

import { IRCCPGeneralData, IRCCPGeneralDataById, IRCCPMovement } from './../../shared/models/recompepsi.interface';

/**
 * * Obtiene datos generales del programa de lealtad
 */
export const getGeneralData = createAction(
    '[GetGeneralData] Get General Data'
);

export const successGetGeneralData = createAction(
    '[GetGeneralData] Get General Data Success',
    props<IRCCPGeneralData>()
);

export const errorGetGeneralData = createAction(
    '[GetGeneralData] Get General Data Error',
    props<{ payload: Error; }>()
);

export const getGeneralDataClear = createAction(
    '[GetGeneralDataClear] Get General Data Clear'
);

/**
 * * Obtiene datos generales del programa de lealtad por id
 */
export const getGeneralDataById = createAction(
    '[GetGeneralDataById] Get General Data By Id',
    props<{ idPilar: number }>()
);

export const successGetGeneralDataById = createAction(
    '[GetGeneralDataById] Get General Data By Id Success',
    props<IRCCPGeneralDataById>()
);

export const errorGetGeneralDataById = createAction(
    '[GetGeneralDataById] Get General Data By Id Error',
    props<{ payload: Error; }>()
);

export const getGeneralDataByIdClear = createAction(
    '[GetGeneralDataByIdClear] Get General Data By Id Clear'
);

/**
 * * Obtiene movimientos del programa de lealtad
 */
export const getMovements = createAction(
    '[GetMovements] Get Movements',
    props<{ mes: number; anio: number; }>()
);

export const successGetMovements = createAction(
    '[GetMovements] Get Movements Success',
    props<IRCCPMovement>()
);

export const errorGetMovements = createAction(
    '[GetMovements] Get Movements Error',
    props<{ payload: Error; }>()
);

export const getMovementsClear = createAction(
    '[GetMovementsClear] Get Movements Clear'
);

